import { render, staticRenderFns } from "./FloorsTable.vue?vue&type=template&id=7fda1253&scoped=true&"
import script from "./FloorsTable.vue?vue&type=script&lang=js&"
export * from "./FloorsTable.vue?vue&type=script&lang=js&"
import style0 from "./FloorsTable.vue?vue&type=style&index=0&id=7fda1253&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fda1253",
  null
  
)

export default component.exports